import React,{useEffect,useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {Trophy,Award} from 'lucide-react';
import {api} from '../lib/api';
export const Leaderboard=()=>{
 const{t}=useTranslation();const[data,setData]=useState<any>(null);
 useEffect(()=>{api.get('/leaderboard').then(r=>setData(r.data)).catch(()=>setData({items:[],founders:0}));},[]);
 if(!data)return null;
 return <section className="leaderboard" data-testid="leaderboard"><div className="leaderboard-head"><Trophy size={18}/><div><h2>{t('Classement des parrains')}</h2><p>{data.founders} {t('membres fondateurs à ce jour')}</p></div></div>
  {data.items.length?<ol className="leaderboard-list">{data.items.map((r:any,i:number)=><li key={i} data-testid={`leaderboard-row-${i}`}><span className={`rank r${i+1}`}>{i+1}</span><div><strong>{r.name}</strong>{r.city&&<small>{r.city}</small>}</div><b>{r.count} <span>{t('invités')}</span></b></li>)}</ol>:<p className="muted" data-testid="leaderboard-empty">{t('Soyez le premier à inviter vos amis !')}</p>}
  <Link to="/profile" className="sq-button" data-testid="leaderboard-join"><Award size={15}/>{t('Rejoindre le classement')}</Link>
 </section>;
};
